import { addPreservedParams } from "@mozioinc/utils";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type PreservedLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children?: ReactNode;
};

export const PreservedLink = ({
  href,
  children,
  ...props
}: PreservedLinkProps) => {
  const preservedHref = href ? addPreservedParams(href) : href;

  return (
    <a {...props} href={preservedHref}>
      {children}
    </a>
  );
};
